import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BrandingService } from '../../../core/services/branding.service';

@Component({
    selector: 'app-account-disabled',
    templateUrl: './account-disabled.component.html',
    styleUrls: ['./account-disabled.component.css'],
    standalone: false
})
export class AccountDisabledComponent implements OnInit {

  get supportEmail(): string {
    return this.brandingService.getSupportEmail();
  }

  get logoPath(): string {
    return this.brandingService.getLogoPath();
  }

  constructor(private router: Router, private brandingService: BrandingService) {
  }

  ngOnInit() {
  }

  reload() {
    this.router.navigate(['/login']);
  }
}
